import apiFetch from '../../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `TipoIntervencion`, method: 'GET', body: null, token: token})
}
